"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GaiaStreamClientBuilder = exports.GaiaStreamClientFactory = void 0;
var __1 = require("..");
var GaiaStreamClient_1 = require("./GaiaStreamClient");
var StreamHttpTransporter_1 = require("../http/StreamHttpTransporter");
var GaiaStreamClientFactory = /** @class */ (function () {
    function GaiaStreamClientFactory() {
    }
    GaiaStreamClientFactory.prototype.http = function (url) {
        return GaiaStreamClientBuilder.http(url);
    };
    return GaiaStreamClientFactory;
}());
exports.GaiaStreamClientFactory = GaiaStreamClientFactory;
var GaiaStreamClientBuilder = /** @class */ (function () {
    function GaiaStreamClientBuilder(transporter) {
        this.contentType = 'application/json';
        this.transporter = transporter;
    }
    GaiaStreamClientBuilder.http = function (url) {
        return new GaiaStreamClientBuilder(new StreamHttpTransporter_1.StreamHttpTransporter(url));
    };
    GaiaStreamClientBuilder.prototype.withCredentials = function (credentials) {
        this.credentials = credentials;
        return this;
    };
    GaiaStreamClientBuilder.prototype.withContentType = function (contentType) {
        this.contentType = contentType;
        return this;
    };
    GaiaStreamClientBuilder.prototype.build = function () {
        var options = new __1.ClientOptions(this.credentials, this.contentType);
        return new GaiaStreamClient_1.GaiaStreamClient(options, this.transporter);
    };
    return GaiaStreamClientBuilder;
}());
exports.GaiaStreamClientBuilder = GaiaStreamClientBuilder;
//# sourceMappingURL=GaiaStreamClientBuilder.js.map